import { useGetChatroomStats } from '@pba/react-network';
import { useMemo } from 'react';

export const useUnreadMessages = () => {
  const { data } = useGetChatroomStats();

  return useMemo(() => data?.reduce((total, item) => total + item.unread, 0) ?? 0, [data]);
};
